import React from 'react';
import { useHistory } from 'react-router';

import { track } from 'utils/analytics';
import { useClassName } from 'common/hooks';

export default function BookTicketsAnnouncement({ announcement, setActive }) {
  const className = useClassName('BookTickets');
  const history = useHistory();

  const handleAnnouncementClick = (link) => {
    if (!link) return;
    track('Book Tickets Announcement Pressed', { label: link });
    setActive(false);

    const url = new URL(link, window.location.origin);
    if (url.origin !== window.location.origin) {
      window.location.href = url.href;
      return;
    }

    const path = `${url.pathname}${url.search}${url.hash}`;
    const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (path === current) window.location.reload();
    else history.push(path);
  };

  const getBackground = (announcement) => {
    if (!announcement?.backgroundImage)
      return { backgroundColor: announcement.backgroundColor };
    return {
      backgroundImage: `url(${announcement?.backgroundImage?.assetUrl})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    };
  };
  return (
    <div
      className={className('book-announcement')}
      key={announcement.name}
      style={getBackground(announcement)}
      onClick={() => handleAnnouncementClick(announcement.link)}>
      {announcement.image?.assetUrl && (
        <img
          src={announcement.image.assetUrl}
          alt={announcement.image.assetAlt}
        />
      )}
    </div>
  );
}
